// extracted by mini-css-extract-plugin
export var button = "Post-module--button--51f8f";
export var comments = "Post-module--comments--d3b99";
export var content = "Post-module--content--3c6e5";
export var footer = "Post-module--footer--f8705";
export var post = "Post-module--post--3a994";